
export const breakpoints = {
  sm: '(min-width: 30em)',
  md: '(min-width: 48em)',
  lg: '(min-width: 59em)'
}

const config = {
  breakpoints
}

export default config

